import { render, staticRenderFns } from "./SplitWrapper.vue?vue&type=template&id=37a15f43&lang=pug&"
import script from "./SplitWrapper.vue?vue&type=script&lang=js&"
export * from "./SplitWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SplitWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a15f43')) {
      api.createRecord('37a15f43', component.options)
    } else {
      api.reload('37a15f43', component.options)
    }
    module.hot.accept("./SplitWrapper.vue?vue&type=template&id=37a15f43&lang=pug&", function () {
      api.rerender('37a15f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/SplitWrapper.vue"
export default component.exports